import dayjs from 'dayjs';
import customParseFormat from "dayjs/plugin/customParseFormat";
dayjs.extend(customParseFormat);
import {z} from 'zod';

export const SearchParams = z.object({
    
    date: z.string().default(dayjs().format('YYYY-MM-DD')),
});

export type SearchParams = z.infer<typeof SearchParams>;